export default __webpack_public_path__ + "static/media/redirect.63d0efa3.png";